import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Container, Header, Divider } from 'semantic-ui-react';

export type ContainerType = 'normal' | 'wide' | 'userList';

type Props = {
  headerTitle?: string;
  hasHeaderDivider: boolean;
  hasInnerWrapper: boolean;
  containerType?: ContainerType;
  className?: string;
  children: ReactNode;
};

const Component: React.FC<Props> = (props) => {
  const {
    children,
    headerTitle,
    className,
    hasInnerWrapper,
    hasHeaderDivider,
  } = props;

  return (
    <Container text={true} className={className}>
      {hasInnerWrapper ? (
        <InnerWrapper>
          {headerTitle && <StyledHeader>{headerTitle}</StyledHeader>}
          {hasHeaderDivider && <Divider hidden={true} />}
          {children}
        </InnerWrapper>
      ) : (
        <>
          {headerTitle && <StyledHeader>{headerTitle}</StyledHeader>}
          {hasHeaderDivider && <Divider hidden={true} />}
          {children}
        </>
      )}
    </Container>
  );
};

const StyledHeader = styled(Header)`
  &&& {
    margin: 2em 0 1em;
    font-size: 1.5em;
  }
`;

const InnerWrapper = styled.div`
  margin: 3em auto;
`;

const NormalStyle = css`
  width: 700px;
  padding: 0 0 48px;
`;

const WideStyle = css`
  width: 930px;
  padding: 0 0 48px;
`;

const UserListStyle = css`
  width: 960px;
  padding-top: 48px;
  margin: 0 auto;
`;

export const StyledContainer = styled(Component)`
  &&& {
    max-width: none !important;
    flex: 1 0 auto;
    ${({ containerType }) =>
      (containerType === 'normal' && NormalStyle) ||
      (containerType === 'wide' && WideStyle) ||
      (containerType === 'userList' && UserListStyle)}
  }
`;
